import * as React from "react";
import MuiToggleButton from "@mui/material/ToggleButton";

import styles from "./Toggelbutton.module.scss";
import { styled } from "@mui/material/styles";
import i18next from "i18next";
import { Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";

const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "#2C3E50",
    backgroundColor: selectedColor,
  },
}));

export default function ColorToggleButton(props) {
  const { handelvalue, selectedDay } = props;

  return (
    <Tabs
      value={selectedDay}
      exclusive
      onChange={handelvalue}
      aria-label="Platform"
      className={styles.toggelStyle}
      data-testid="ToggelButton"
    >
      <Tab
        label={i18next.t("Today")}
        className={styles.selectedDay}
        selectedColor=""
        value="today"
      />
      <Tab
        label={i18next.t("last 7 days")}
        className={styles.selectedDay}
        selectedColor=""
        value="week"
      />
      <Tab
        label={i18next.t("last 30 days")}
        className={styles.selectedDay}
        selectedColor=""
        value="month"
      />
    </Tabs>
  );
}

ColorToggleButton.propTypes = {
  handelvalue:PropTypes.any, 
  selectedDay:PropTypes.any
}